import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/reducer/authReducer"; // Adjust the path as needed
import CustomTitleWihBox from "../sharedComponents/customTitleWithBox";
import CustomInput from "./CustomInput";
import { EnvelopeIcon, LockOpenIcon } from "@heroicons/react/24/outline";
import CustomPasswordInput from "../accountUser/customPasswordInput";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import GoogleIcon from "../sharedComponents/GoogleIcon";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  // const navigate = useNavigate(); // Use the useNavigate hook
  const { t } = useTranslation();
  const navigateWithLang = useLanguageNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.removeItem("email");

    // Dispatch loginUser with email and password
    dispatch(loginUser({ email, password }))
      .unwrap() // Unwrap the action result to handle the response
      .then((response) => {
        // console.log(response)
        if (response.returnToSignup) {
          return navigateWithLang("/otp");
        }

        // Optionally, use the custom handleClick to navigate and reload the page
        localStorage.setItem("accessToken", response.accessToken);
        handleClick();
      })
      .catch((error) => {
        // Optionally handle login errors if needed
        console.error(t("Loginffailed"), error);
        alert(t("LoginFailed"));
      });
  };

  // handleClick to perform the navigation and force page reload
  const handleClick = () => {
    navigateWithLang("/my-account/dashboard");
  };
  const direction = useLanguageDirection();

  return (
    <div
      className="block p-8 mx-auto bg-white rounded-lg shadow-lg md:w-2/3 max-w-[700px]"
      dir={direction}
    >
      <CustomTitleWihBox title={t("LoginTitle")} />
      <form onSubmit={handleSubmit} className="">
        <div className="md:flex md:gap-3">
          {/* Email */}
          <div className="my-5 mb-6 md:w-1/2">
            <CustomInput
              id="email"
              type="email"
              placeholder={t("EnterYourEmail")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              icon={<EnvelopeIcon />}
              required
            />
          </div>

          {/* Password */}
          <div className="my-5 mb-6 md:w-1/2">
            <CustomPasswordInput
              id="password"
              // label={t("Password")}
              placeholder={t("Enteryourpassword")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              icon={<LockOpenIcon />}
              required
            />
          </div>
        </div>
        <div
          onClick={() => navigateWithLang("/forget-password")}
          className="mb-6 text-blue-600 cursor-pointer hover:underline"
        >
          {t("ForgotPassword")}
        </div>

        {/* Submit Button */}
        <div className="flex flex-col justify-center gap-4 md:mb-6">
          <button
            type="submit"
            className="block w-full px-6 py-2 font-medium text-black uppercase transition duration-150 ease-in-out rounded-lg shadow-lg lg:text-lg lg:py-3 bg-custom-yellow hover:bg-primary-600 focus:outline-none"
          >
            {t("LoginTitle")}
          </button>
          <button
            type="button"
            className="flex items-center justify-center w-full gap-2 px-4 py-3 font-medium text-black duration-300 border rounded-lg border-custom-primary text-custom-primary hover:bg-custom-yellow lg:text-lg"
            onClick={() =>
              (window.location.href = "https://api.markaship.com/api/google")
            }
          >
            <GoogleIcon />
            <span className="flex-grow text-center">
              {t("googleSignInText")}
            </span>
            <span className="w-5"></span>
          </button>
        </div>

        {/* Navigation to Registration */}
        <p className="text-sm text-center text-gray-600">
          {t("NoAccount")}{" "}
          <div
            onClick={() => navigateWithLang("/registration")}
            className="text-blue-600 cursor-pointer hover:underline "
          >
            {t("RegisterHere")}
          </div>
        </p>
      </form>
    </div>
  );
}
